import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import PressableStyled from '../../../../../components/PressableStyled';
import CloseIconSmall from '../../../../../components/12pxIcons/CloseIconSmall';
import Colors from '../../../../../constants/Colors';
import Style from '../../../../../constants/Style';

interface AssetFilterTagProps {
  label: string,
  value: string,
  remove: () => void,
}

const AssetFilterTag = ({
  label, value, remove,
}: AssetFilterTagProps) => <View style={styles.item}>
    <Text style={styles.label}>
      {`${label}: `}
      <Text style={styles.value}>{value}</Text>
    </Text>
    <PressableStyled onPress={remove}>
      <CloseIconSmall />
    </PressableStyled>
  </View>;

const styles = StyleSheet.create({
  label: {
    color: Colors.light.hereworksBlack400,
    fontFamily: 'Roboto_400Regular',
    fontSize: 12,
    lineHeight: 14,
    marginEnd: 8,
  },
  value: {
    color: Colors.light.hereworksBlack600,
  },
  item: {
    ...Style.row,
    borderRadius: 4,
    paddingVertical: 4,
    paddingHorizontal: 12,
    borderWidth: 1,
    marginEnd: 8,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: Colors.light.hereworksWhite100,
    marginBottom: 4,
  },
});

export default AssetFilterTag;
